@if (selectedDashboard?.dashboardTiles?.length > 0 || (callState | lcsCallState : 'loading')) { @if
(selectedDashboard?.dashboardTiles) {
<ktd-grid
   [class.is-editing]="isEditing"
   [trackById]="trackById"
   [cols]="cols"
   [gap]="12"
   [rowHeight]="rowHeight"
   [layout]="displayLayout"
   [scrollableParent]="'dashboard-scroll-container'"
   (layoutUpdated)="onLayoutUpdated($event)"
>
   @for (tile of selectedDashboard.dashboardTiles; track tile) {
   <ktd-grid-item
      [resizable]="isEditing"
      [draggable]="isEditing"
      [id]="tile.dashboardTileLayoutConfiguration.dashboardTileLayoutConfigurationId"
   >
      <ndt-tile-wrapper [attr.id]="tile.dashboardTileId" [tileConfig]="tile" [isEditing]="isEditing"></ndt-tile-wrapper>
   </ktd-grid-item>
   }
</ktd-grid>
} } @else {
<div class="dashboard-fallback">
   @if (!selectedDashboard) {
   <div class="dashboard-empty">
      <div class="dashboard-empty_icon">
         <mat-icon>space_dashboard</mat-icon>
      </div>
      <h2>No dashboard yet</h2>
      <button type="button" mat-raised-button (click)="onAddDashboard()">
         <mat-icon>add</mat-icon>
         Create dashboard
      </button>
   </div>
   } @else {
   <div class="dashboard-empty">
      <div class="dashboard-empty_icon">
         <mat-icon>grid_view</mat-icon>
      </div>
      <h2>This dashboard is empty</h2>
      <button type="button" mat-raised-button (click)="onAddTile()">
         <mat-icon>add</mat-icon>
         Add tile
      </button>
   </div>
   }
</div>
}
